import React from 'react'

const PreQualifyHeader = () => {
  return (
    <div className="tw-mb-5 tw-border-2 tw-border-brand-success tw-px-4 tw-py-2 tw-text-center">
      <h2 className="h2 tw-mb-2 !tw-text-brand-success">You are Pre-Qualified!</h2>
      <p className="tw-mb-1 tw-text-sm tw-font-medium tw-text-brand-body_text--muted">
        This is a pre-qualification, based on a soft credit inquiry and does not guarantee final
        loan approval.
      </p>
    </div>
  )
}

export default PreQualifyHeader
